import { render } from "./TramitesPlaObs.vue?vue&type=template&id=cff0a30c&scoped=true"
import script from "./TramitesPlaObs.vue?vue&type=script&lang=js"
export * from "./TramitesPlaObs.vue?vue&type=script&lang=js"

import "./TramitesPlaObs.vue?vue&type=style&index=0&id=cff0a30c&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cff0a30c"]])

export default __exports__